<app-import-theme-bar
  [mode]="mode$ | async"
  (changeMode)="changeMode($event)"
  (showThemeImport)="showedThemeImport = $event"
></app-import-theme-bar>
<div class="m-h-100vh tracking-page-search-page" [ngClass]="(mode$ | async)" [class.show-import]="showedThemeImport">
  <div
    class="loader inner-right-img text-center"
    *ngIf="!(trackingPageLoaded$ | async); else trackingPage"
  >
    <div>
      <img class="img-fluid" src="/assets/img/spinner.gif" />
      <p class="loading">Loading</p>
    </div>
  </div>
  <ng-template #trackingPage>
    <app-tracking-page-search
      (triggerSearchNumber)="searchNumber($event)"
      (triggerBackToSearch)="backToSearch()"
      [noNumbers]="noTrackingNumber$ | async"
      [trackingPage]="trackingPage$ | async"
      (changeLanguage)="changeLanguage($event)"
      [isVisualBuilder]="false"
      [mode]="mode$ | async"
    >
    </app-tracking-page-search>
  </ng-template>
</div>
